import { Routes, Route } from 'react-router-dom';
import AppLayout from './layouts/AppLayout';
import Dashboard from './pages/Dashboard';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import TaskDetail from './pages/TaskDetail';
import Instances from './pages/Instances';
import InstanceDetail from './pages/InstanceDetail';
import GlobalInstances from './pages/GlobalInstances';
import GlobalAgents from './pages/GlobalAgents';
import Runners from './pages/Runners';
import RunnerDetail from './pages/RunnerDetail';
import Skills from './pages/Skills';
import SkillDetail from './pages/SkillDetail';
import AgentSkills from './pages/AgentSkills';
import AgentDetail from './pages/AgentDetail';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import SshHosts from './pages/SshHosts';
import SshHostForm from './pages/SshHostForm';
import RelaySessions from './pages/RelaySessions';
import RelaySessionPage from './pages/RelaySession';
import OperatorConsole from './pages/OperatorConsole';
import RunGroupDetail from './pages/RunGroupDetail';
import WorkerAttempts from './pages/WorkerAttempts';
import Docs from './pages/Docs';
import DocPage from './pages/DocPage';

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/instances" element={<GlobalInstances />} />
        <Route path="/agents" element={<GlobalAgents />} />
        <Route path="/operator" element={<OperatorConsole />} />
        <Route path="/operator/run-groups/:id" element={<RunGroupDetail />} />
        <Route path="/operator/workers/:id" element={<WorkerAttempts />} />
        <Route path="/runners" element={<Runners />} />
        <Route path="/runners/:id" element={<RunnerDetail />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:id" element={<ProjectDetail />} />
        <Route path="/tasks/:id" element={<TaskDetail />} />
        <Route path="/projects/:id/instances" element={<Instances />} />
        <Route path="/projects/:id/analytics" element={<Analytics />} />
        <Route path="/projects/:id/skills" element={<Skills />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/skills/:id" element={<SkillDetail />} />
        <Route path="/agent-skills" element={<AgentSkills />} />
        <Route path="/agents/:id" element={<AgentDetail />} />
        <Route path="/instances/:id" element={<InstanceDetail />} />
        <Route path="/projects/:id/teams" element={<Teams />} />
        <Route path="/teams/:id" element={<TeamDetail />} />
        <Route path="/ssh-hosts" element={<SshHosts />} />
        <Route path="/ssh-hosts/new" element={<SshHostForm />} />
        <Route path="/ssh-hosts/:id" element={<SshHostForm />} />
        <Route path="/relay" element={<RelaySessions />} />
        <Route path="/relay/:id" element={<RelaySessionPage />} />
        <Route path="/docs" element={<Docs />}>
          <Route index element={<DocPage />} />
          <Route path=":slug" element={<DocPage />} />
        </Route>
        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
}
